import axios from 'axios';
import { GET_LINE_OPTIC_HIGHWAY_API_URL, GET_WELL_HIGHWAY_API_URL, GET_PILLAR_HIGHWAY_API_URL,
  GET_GOUPLING_HIGHWAY_API_URL, GET_FOB_HIGHWAY_API_URL, GET_SUMMIT_HIGHWAY_API_URL,
  GET_EQUIPMENT_CANTON_API_URL, GET_WELL_CANTON_API_URL, GET_PILLAR_CANTON_API_URL,
  GET_COUPLING_CANTON_API_URL, GET_FOB_CANTON_API_URL, GET_LINE_OPTIC_CANTON_API_URL, GET_PON_BOX_CANTON_API_URL,
  GET_HOUSES_POLIGON_API_URL,
  GET_KTV_AMPLIFIER_COORDINATE_API_URL,
  GET_KTV_OP_COORDINATE_API_URL,
  GET_DIVIDER_COORDINATE_API_URL,
  GET_LINE_OPTIC_BY_ID_CANTON_API_URL,
  GET_PASSIVE_NODE_CANTON_API_URL,
  GET_KTV_AMPLIFIER_PASSIVE_NODE_COORDINATE_API_URL} from '../OpticApiConfig';
import { radiusWell, radiusPillar, CONST_HIGHWAY, CONST_CANTON } from '../Constants/ConstantsOptics';  

// отображение оптики для карты (параметры опты)
const processLineOpticData = (lineOpticData) => {
    const groupedCoordinatesWithColorTypeAndWidth = lineOpticData.reduce((acc, coordinate) => {
      if (!acc[coordinate.highwayLineId]) {
        acc[coordinate.highwayLineId] = {
          coordinates: [],
          color: coordinate.cableColor,
          type: coordinate.cableTypeKind,
          width: coordinate.cableWidth,
          fiberQuantity: coordinate.cableFiberQuantity,
          activity: coordinate.activity,
          pon: coordinate.pon,
          ktv: coordinate.ktv,
          ether: coordinate.ether,
          cableTypeId: coordinate.cableTypeId,
          rankCableId: coordinate.rankCableId,
     };
      }
      acc[coordinate.highwayLineId].coordinates.push([coordinate.latitude, coordinate.longitude]);
      return acc;
    }, {});
    return groupedCoordinatesWithColorTypeAndWidth;
  };

  // формируем Territory для кабеля
  function generateTerritoryByHighwayLineId(data) {
    const territoryByHighwayLineId = {};
  
    // Группируем данные по highwayLineId, canton и region
    const groupedByCanton = data.reduce((acc, item) => {
      const { highwayLineId, canton, region, area } = item;
  
      // Исключаем элементы, где canton, region или area равны нулю
      if (canton && region && area) {
        if (!acc[highwayLineId]) acc[highwayLineId] = {};
        if (!acc[highwayLineId][canton]) acc[highwayLineId][canton] = {};
        if (!acc[highwayLineId][canton][region]) acc[highwayLineId][canton][region] = new Set();
  
        acc[highwayLineId][canton][region].add(area);
      }
  
      return acc;
    }, {});
  
    // Формируем массив territory для каждого highwayLineId
    for (const highwayLineId in groupedByCanton) {
      const cantons = groupedByCanton[highwayLineId];
      const territory = [];
  
      for (const canton in cantons) {
        const regions = cantons[canton];
        const regionArray = [];
  
        for (const region in regions) {
          regionArray.push({
            region,
            areas: Array.from(regions[region]), 
          });
        }
  
        territory.push({
          canton,
          regions: regionArray,
        });
      }
  
      territoryByHighwayLineId[highwayLineId] = territory;
    }
  
    return territoryByHighwayLineId;
  }

  //NEW отображение территории из фильтра (Город / Страна)
  export const GetHighwayFilter = async (setSwitchesData, setWellData, setPillarData, setCouplingLocationData, setFobLocationData,setPonBoxLocationData, setGroupedCoordinatesWithColorTypeAndWidth, 
    setLoadingSummit, selectedCity, setPosition, setStatusModalTerritory, setDescriptionOptic, setProblemCableData ) => {

    setSwitchesData([]);
    setWellData([]);
    setPillarData([]);
    setCouplingLocationData([]);
    setFobLocationData([]);
    setGroupedCoordinatesWithColorTypeAndWidth([]);
    setLoadingSummit(true);
    setProblemCableData([]);
    setPonBoxLocationData([]);
  
    if (selectedCity === "null") {
      // console.error("Выберите город!");
      return;
    }
  
    const token = localStorage.getItem('token');
    const headers = { 'Authorization': `Bearer ${token}` };
  
    const apiUrls = {
      lineOptic: `${GET_LINE_OPTIC_HIGHWAY_API_URL}?city=${selectedCity}`,
      well: `${GET_WELL_HIGHWAY_API_URL}?city=${selectedCity}`,
      pillar: `${GET_PILLAR_HIGHWAY_API_URL}?city=${selectedCity}`,
      coupling: `${GET_GOUPLING_HIGHWAY_API_URL}?city=${selectedCity}`,
      fob: `${GET_FOB_HIGHWAY_API_URL}?city=${selectedCity}`,
      summit: `${GET_SUMMIT_HIGHWAY_API_URL}?city=${selectedCity}`,
    };
  
    try {
  
      const [
        resultSummitCoordinate,
        resultWellHighway,
        resultPillarHighway,
        resultCouplingHighway,
        resultFobHighway,
        resultLineOpticHighway
      ] = await Promise.all([
        axios.get(apiUrls.summit, { headers }),
        axios.get(apiUrls.well, { headers }),
        axios.get(apiUrls.pillar, { headers }),
        axios.get(apiUrls.coupling, { headers }),
        axios.get(apiUrls.fob, { headers }),
        axios.get(apiUrls.lineOptic, { headers })
      ]);
  
      const { latitude, longitude } = resultSummitCoordinate.data[0];
      setPosition([latitude, longitude]);
      setSwitchesData(resultSummitCoordinate.data);
      setStatusModalTerritory(CONST_HIGHWAY);
  
      setWellData(resultWellHighway.data);
      setPillarData(resultPillarHighway.data);
      setCouplingLocationData(resultCouplingHighway.data);
      setFobLocationData(resultFobHighway.data);
      setProblemCableData(resultLineOpticHighway.data.problemLines);
       
       const uniqueData = resultLineOpticHighway.data.listLineOpticHighwayCoordinate.filter(
         (item, index, self) => index === self.findIndex(t => t.id === item.id)
       );
      
      const processedData = processLineOpticData(resultLineOpticHighway.data.listLineOpticHighwayCoordinate);
      setGroupedCoordinatesWithColorTypeAndWidth(processedData);
      setDescriptionOptic(uniqueData);
  
    } catch (error) {
      // Обработка ошибок (например, вывод сообщения или запись в лог)
      // console.error("Error fetching data:", error);
    } finally {
      setLoadingSummit(false);
    }
  };

//OLD отображение территории из фильтра (Город / Страна)
// export const GetHighwayFilter = async (setSwitchesData, setWellData, setPillarData, setCouplingLocationData, 
//         setFobLocationData, setGroupedCoordinatesWithColorTypeAndWidth, setLoadingSummit, selectedCity, setPosition, setStatusModalTerritory,setDescriptionOptic) => {  

//       setSwitchesData([]);
//       setWellData([]);
//       setPillarData([]);
//       setCouplingLocationData([]);
//       setFobLocationData([]);
//       setGroupedCoordinatesWithColorTypeAndWidth([]);
//       setLoadingSummit(true);
      
//       try {
//         if (selectedCity === "null") {
//          // console.error("Выберите город!");
//           return;
//         }

//         console.time('Request Time'); // Начало измерения времени

//         const token = localStorage.getItem('token');
           
//         let apiUrlLineOpticHighway = `${GET_LINE_OPTIC_HIGHWAY_API_URL}?city=${selectedCity}`;
        
//         let apiUrlWellHighway = `${GET_WELL_HIGHWAY_API_URL}?city=${selectedCity}`;

//         let apiUrlPillarHighway = `${GET_PILLAR_HIGHWAY_API_URL}?city=${selectedCity}`;

//         let apiUrlCouplingHighway = `${GET_GOUPLING_HIGHWAY_API_URL}?city=${selectedCity}`;

//         let apiUrlFobHighway = `${GET_FOB_HIGHWAY_API_URL}?city=${selectedCity}`;

//         let apiUrlSummitCoordinate = `${GET_SUMMIT_HIGHWAY_API_URL}?city=${selectedCity}`;

//         const resultSummitCoordinate  = await axios.get(apiUrlSummitCoordinate,{
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         const { latitude, longitude } = resultSummitCoordinate.data[0];
//         setPosition([latitude, longitude]);
//         setSwitchesData(resultSummitCoordinate.data);
//         setStatusModalTerritory('highway');

//         const resultWelllHighway = await axios.get(apiUrlWellHighway, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setWellData(resultWelllHighway.data);

//          const resultPillarHighway = await axios.get(apiUrlPillarHighway, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//          });
//          setPillarData(resultPillarHighway.data);

//         const resultCouplingHighway = await axios.get(apiUrlCouplingHighway, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setCouplingLocationData(resultCouplingHighway.data);

//         const resultFobHighway = await axios.get(apiUrlFobHighway, { 
//           headers:{
//             'Authorization': `Bearer ${token}` 
//         }});
//         setFobLocationData(resultFobHighway.data);

//         try {
//           const resultLineOpticHighway = await axios.get(apiUrlLineOpticHighway, {
//             headers:{
//               'Authorization': `Bearer ${token}` 
//             }
//           });
//           const uniqueData = resultLineOpticHighway.data.filter((item, index, self) =>
//           index === self.findIndex((t) => t.id === item.id)
//         );

//         console.timeEnd('Request Time'); // Завершение измерения времени

//         const processedData = processLineOpticData(resultLineOpticHighway.data); 
//         setGroupedCoordinatesWithColorTypeAndWidth(processedData);
//         setDescriptionOptic(uniqueData);

//         } catch (error) {
//          // console.error("Error fetching LineOptic data:", error);
//         }
//       } catch (error) {
//        // console.error("Error fetching data:", error);
//       } finally {
//         setLoadingSummit(false);
//       }

//     }

// NEW отображение территории из фильтра (Округ / Регион / Ветка)
    export const GetCantonFilter = async ( selectedRegionRef, selectedAreaRef, selectedCanton, setSwitchesData, setWellData, setPillarData, setCouplingLocationData, setFobLocationData,
      setGroupedCoordinatesWithColorTypeAndWidth, setLoadingCunton, setPosition, setStatusModalTerritory, setDescriptionOptic, setPonBoxLocationData, setHousesData, setktvAmplifierData,
      setktvOpData, setProblemCableData, setDividerData, setPassiveNodeLocationData ) => {

      const selectedRegion = selectedRegionRef.current.value;
      const selectedArea = selectedAreaRef.current.value;
    
      // Сбрасываем данные
      setSwitchesData([]);
      setHousesData([]);
      setWellData([]);
      setPillarData([]);
      setPonBoxLocationData([]);
      setCouplingLocationData([]);
      setFobLocationData([]);
      setGroupedCoordinatesWithColorTypeAndWidth([]);
      setLoadingCunton(true);
      setktvAmplifierData([]);
      setktvOpData([]);
      setDividerData([]);
      setProblemCableData([]);
      setPassiveNodeLocationData([]);
    
      if (selectedCanton === "null") {
        return;
      }
    
      const token = localStorage.getItem('token');
      const apiUrl = `${GET_EQUIPMENT_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;
    
      try {
        // Один запрос для получения оборудования
        const resultEquipment = await axios.get(apiUrl, {
          headers: { 'Authorization': `Bearer ${token}` },
        });
    
        const { latitude, longitude } = resultEquipment.data[0];
        setPosition([latitude, longitude]);
        setSwitchesData(resultEquipment.data);
        setStatusModalTerritory(CONST_CANTON);
    
        // Параллельные запросы для других данных
        const apiUrls = {
          housesPoligon: `${GET_HOUSES_POLIGON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`,
          well: `${GET_WELL_CANTON_API_URL}?radius=${radiusWell}&centerLat=${latitude}&centerLon=${longitude}`,
          pillar: `${GET_PILLAR_CANTON_API_URL}?radius=${radiusPillar}&centerLat=${latitude}&centerLon=${longitude}`,
          couplingLocation: `${GET_COUPLING_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`,
          fobLocation: `${GET_FOB_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`,
          ponBoxLocation: `${GET_PON_BOX_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`,
          lineOptic: `${GET_LINE_OPTIC_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`,
          ktvAmplifier: `${GET_KTV_AMPLIFIER_COORDINATE_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`,
          ktvOp: `${GET_KTV_OP_COORDINATE_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`,
          divider: `${GET_DIVIDER_COORDINATE_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`,
          passiveNodeLocation: `${GET_PASSIVE_NODE_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`,
        };

    
        // Параллельные запросы
        const [
          resultHousesPoligon,
          resultWell,
          resultPillar,
          resultCouplingLocation,
          resultFobLocation,
          resultPonBoxLocation,
          resultLineOptic,
          resultktvOp,
          resultktvAmplifier, 
          resultDivider,  
          resultPassiveNode, 
        ] = await Promise.all([
          axios.get(apiUrls.housesPoligon, { headers: { 'Authorization': `Bearer ${token}` } }),
          axios.get(apiUrls.well, { headers: { 'Authorization': `Bearer ${token}` } }),
          axios.get(apiUrls.pillar, { headers: { 'Authorization': `Bearer ${token}` } }),
          axios.get(apiUrls.couplingLocation, { headers: { 'Authorization': `Bearer ${token}` } }),
          axios.get(apiUrls.fobLocation, { headers: { 'Authorization': `Bearer ${token}` } }),
          axios.get(apiUrls.ponBoxLocation, { headers: { 'Authorization': `Bearer ${token}` } }),
          axios.get(apiUrls.lineOptic, { headers: { 'Authorization': `Bearer ${token}` } }),
          axios.get(apiUrls.ktvOp, { headers: { 'Authorization': `Bearer ${token}` } }),
          axios.get(apiUrls.ktvAmplifier, { headers: { 'Authorization': `Bearer ${token}` } }),
          axios.get(apiUrls.divider, { headers: { 'Authorization': `Bearer ${token}` } }),
          axios.get(apiUrls.passiveNodeLocation, { headers: { 'Authorization': `Bearer ${token}` } }),
        ]);
    
        // Устанавливаем полученные данные
        setHousesData(resultHousesPoligon.data);
        setWellData(resultWell.data);
        setPillarData(resultPillar.data);
        setCouplingLocationData(resultCouplingLocation.data);
        setFobLocationData(resultFobLocation.data);
        setPonBoxLocationData(resultPonBoxLocation.data);
        setktvOpData(resultktvOp.data);
        setktvAmplifierData(resultktvAmplifier.data);
        setProblemCableData(resultLineOptic.data.problemLines);
        setDividerData(resultDivider.data);
        setPassiveNodeLocationData(resultPassiveNode.data);
       
       // console.log(resultLineOptic);
        // Обработка данных LineOptic
        // const uniqueData = resultLineOptic.data.filter(
        //   (item, index, self) => index === self.findIndex(t => t.id === item.id)
        // );
        const uniqueData = resultLineOptic.data.listLineOpticCoordinate.filter(
          (item, index, self) => index === self.findIndex(t => t.id === item.id)
        );
    
        const territoryByHighwayLineId = generateTerritoryByHighwayLineId(resultLineOptic.data.listLineOpticCoordinate);
    
        const updatedUniqueData = uniqueData.map(item => ({
          ...item,
          territory: territoryByHighwayLineId[item.highwayLineId] || [],
        }));
    
        
        const processedData = processLineOpticData(resultLineOptic.data.listLineOpticCoordinate);
        setGroupedCoordinatesWithColorTypeAndWidth(processedData);
        setDescriptionOptic(updatedUniqueData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoadingCunton(false);
      }
    };

// OLD отображение территории из фильтра (Округ / Регион / Ветка)
// export const GetCantonFilter = async ( selectedRegionRef, selectedAreaRef, selectedCanton, 
//             setSwitchesData, setWellData, setPillarData, setCouplingLocationData, setFobLocationData,
//             setGroupedCoordinatesWithColorTypeAndWidth, setLoadingCunton, setPosition,setStatusModalTerritory,
//             setDescriptionOptic, setPonBoxLocationData, setHousesData) => {  

//       const selectedRegion = selectedRegionRef.current.value;
    
//       const selectedArea = selectedAreaRef.current.value;
//       setSwitchesData([]);
//       setHousesData([]);
//       setWellData([]);
//       setPillarData([]);
//       setPonBoxLocationData([]);
//       setCouplingLocationData([]);
//       setFobLocationData([]);
//       setGroupedCoordinatesWithColorTypeAndWidth([]);
//       setLoadingCunton(true);
      
//       try {
//         if (selectedCanton === "null") {
//          // console.error("Выберите округ!");
//           return;
//         }
//         const token = localStorage.getItem('token');

//         let apiUrlEquipment = `${GET_EQUIPMENT_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//       //  let apiUrlHouses = `${GET_HOUSES_POLIGON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;
         
//         const resultEquipment = await axios.get(apiUrlEquipment, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });  
        
//         // const resultHouses = await axios.get(apiUrlHouses, {
//         //   headers:{
//         //     'Authorization': `Bearer ${token}` 
//         //   }
//         // }); 
//         // setHousesData(resultHouses.data);  

//         const { latitude, longitude } = resultEquipment.data[0];
//         setPosition([latitude, longitude]);
//         setSwitchesData(resultEquipment.data);
//         setStatusModalTerritory('canton');

//          let apiUrlWell = `${GET_WELL_CANTON_API_URL}?radius=${radiusWell}&centerLat=${latitude}&centerLon=${longitude}`;
      
//          let apiUrlPillar = `${GET_PILLAR_CANTON_API_URL}?radius=${radiusPillar}&centerLat=${latitude}&centerLon=${longitude}`;

//          let apiUrlCouplingLocation = `${GET_COUPLING_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//          let apiUrlFobLocation = `${GET_FOB_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//          let apiUrlPonBoxLocation = `${GET_PON_BOX_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//          let apiUrlLineOptic = `${GET_LINE_OPTIC_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//         const resultWell = await axios.get(apiUrlWell, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setWellData(resultWell.data);

//         const resultPillar  = await axios.get(apiUrlPillar, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setPillarData(resultPillar.data);

//         const resultCouplingLocation  = await axios.get(apiUrlCouplingLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setCouplingLocationData(resultCouplingLocation.data);

//         const resultFobLocation  = await axios.get(apiUrlFobLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setFobLocationData(resultFobLocation.data);

//         const resultPonBoxLocation  = await axios.get(apiUrlPonBoxLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setPonBoxLocationData(resultPonBoxLocation.data);

//         try {
//           const resultLineOptic = await axios.get(apiUrlLineOptic, {
//             headers:{
//               'Authorization': `Bearer ${token}` 
//             }
//           });
         
//           const uniqueData = resultLineOptic.data.filter((item, index, self) =>
//             index === self.findIndex((t) => t.id === item.id)
//           );
//           const territoryByHighwayLineId = generateTerritoryByHighwayLineId(resultLineOptic.data);
        
//          // Добавляем territory к uniqueData
//           const updatedUniqueData = uniqueData.map((item) => {
//             const territory = territoryByHighwayLineId[item.highwayLineId] || []; 
//             return { ...item, territory }; 
//           });

//           const processedData = processLineOpticData(resultLineOptic.data); 
//           setGroupedCoordinatesWithColorTypeAndWidth(processedData);
//           //setDescriptionOptic(uniqueData);
//           setDescriptionOptic(updatedUniqueData);
//         } catch (error) {
//           //console.error("Error fetching LineOptic data:", error);
//         }
//       } catch (error) {
//        // console.error("Error fetching data:", error);
//       } finally {
//         setLoadingCunton(false);
//       }
//     }

//NEW отображение территории из фильтра (Округ / Регион / Ветка)  второй метод для перерисовки во внесении DrawerCanton
export const GetCantonFilterRefresh = async (selectedRegoin, selectedArea, selectedCanton, setSwitchesData, setWellData, setPillarData, 
  setCouplingLocationData, setFobLocationData, setGroupedCoordinatesWithColorTypeAndWidth, setLoadingCunton, setPosition, setStatusModalTerritory, 
  setDescriptionOptic, setPonBoxLocationData, setProblemCableData, setDividerData, setktvAmplifierData, setPassiveNodeLocationData) => {

  setSwitchesData([]);
  setWellData([]);
  setPillarData([]);
  setCouplingLocationData([]);
  setFobLocationData([]);
  setPonBoxLocationData([]);
  setGroupedCoordinatesWithColorTypeAndWidth([]);
  setLoadingCunton(true);
  setProblemCableData([]);
  setDividerData([]);
  setktvAmplifierData([]);
  setPassiveNodeLocationData([]);

  if (selectedCanton === "null") {
    // console.error("Выберите округ!");
    return;
  }

  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  
  const apiUrls = {
    equipment: `${GET_EQUIPMENT_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
    well: `${GET_WELL_CANTON_API_URL}?radius=${radiusWell}&centerLat={latitude}&centerLon={longitude}`,
    pillar: `${GET_PILLAR_CANTON_API_URL}?radius=${radiusPillar}&centerLat={latitude}&centerLon={longitude}`,
    coupling: `${GET_COUPLING_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
    fob: `${GET_FOB_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
    lineOptic: `${GET_LINE_OPTIC_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
    ponBox: `${GET_PON_BOX_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
    divider: `${GET_DIVIDER_COORDINATE_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
    ktvAmplifier: `${GET_KTV_AMPLIFIER_COORDINATE_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
    passiveNodeLocation: `${GET_PASSIVE_NODE_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
  };

  try {

    const resultEquipment = await axios.get(apiUrls.equipment, { headers });
    const { latitude, longitude } = resultEquipment.data[0];

    setSwitchesData(resultEquipment.data);
    setStatusModalTerritory(CONST_CANTON);

    // Создание массива запросов
    const apiRequests = [
      axios.get(apiUrls.well.replace('{latitude}', latitude).replace('{longitude}', longitude), { headers }),
      axios.get(apiUrls.pillar.replace('{latitude}', latitude).replace('{longitude}', longitude), { headers }),
      axios.get(apiUrls.coupling, { headers }),
      axios.get(apiUrls.fob, { headers }),
      axios.get(apiUrls.ponBox, { headers }),
      axios.get(apiUrls.lineOptic, { headers }),
      axios.get(apiUrls.divider, { headers}),
      axios.get(apiUrls.ktvAmplifier, { headers}),
      axios.get(apiUrls.passiveNodeLocation, { headers}),
    ];

    const [
      resultWell,
      resultPillar,
      resultCouplingLocation,
      resultFobLocation,
      resultPonBoxLocation,
      resultLineOptic,
      resultDivider,
      resultktvAmplifier,
      resultPassiveNode, 
    ] = await Promise.all(apiRequests);

    setWellData(resultWell.data);
    setPillarData(resultPillar.data);
    setCouplingLocationData(resultCouplingLocation.data);
    setFobLocationData(resultFobLocation.data);
    setPonBoxLocationData(resultPonBoxLocation.data);
    setDividerData(resultDivider.data);
    setktvAmplifierData(resultktvAmplifier.data);
    setPassiveNodeLocationData(resultPassiveNode.data);
    

   

    const uniqueData = resultLineOptic.data.listLineOpticCoordinate.filter(
      (item, index, self) => index === self.findIndex(t => t.id === item.id)
    );

    const territoryByHighwayLineId = generateTerritoryByHighwayLineId(resultLineOptic.data.listLineOpticCoordinate);

    // Добавление territory к uniqueData
    const updatedUniqueData = uniqueData.map((item) => {
      const territory = territoryByHighwayLineId[item.highwayLineId] || []; 
      return { ...item, territory }; 
    });

    const processedData = processLineOpticData(resultLineOptic.data.listLineOpticCoordinate); 
    setGroupedCoordinatesWithColorTypeAndWidth(processedData);
    setDescriptionOptic(updatedUniqueData);
    setProblemCableData(resultLineOptic.data.problemLines);

  } catch (error) {
    // console.error("Error fetching data:", error);
  } finally {
    setLoadingCunton(false);
  }
};

//Refresh NODE(Округ / Регион / Ветка) 
export const GetCantonNodeFilterRefresh = async (selectedRegoin, selectedArea, selectedCanton, setSwitchesData, setFobLocationData,
     setStatusModalTerritory, setPonBoxLocationData, setDividerData, setktvAmplifierData, setGroupedCoordinatesWithColorTypeAndWidth,setProblemCableData, setDescriptionOptic) => {

  setSwitchesData([]);
  setFobLocationData([]);
  setPonBoxLocationData([]);
  setGroupedCoordinatesWithColorTypeAndWidth([]);
  setProblemCableData([]);
  setDividerData([]);
  setktvAmplifierData([]);

  if (selectedCanton === "null") {
    // console.error("Выберите округ!");
    return;
  }

  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  
  const apiUrls = {
   equipment: `${GET_EQUIPMENT_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
   fob: `${GET_FOB_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
   lineOptic: `${GET_LINE_OPTIC_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
   ponBox: `${GET_PON_BOX_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
   divider: `${GET_DIVIDER_COORDINATE_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
   ktvAmplifier: `${GET_KTV_AMPLIFIER_COORDINATE_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`,
  };

  try {

    const resultEquipment = await axios.get(apiUrls.equipment, { headers });

    setSwitchesData(resultEquipment.data);
    setStatusModalTerritory(CONST_CANTON);

    // Создание массива запросов
    const apiRequests = [
      axios.get(apiUrls.fob, { headers }),
      axios.get(apiUrls.ponBox, { headers }),
      axios.get(apiUrls.lineOptic, { headers }),
      axios.get(apiUrls.divider, { headers}),
      axios.get(apiUrls.ktvAmplifier, { headers}),
    ];

    const [
      resultFobLocation,
      resultPonBoxLocation,
      resultLineOptic,
      resultDivider,
      resultktvAmplifier,
    ] = await Promise.all(apiRequests);

     setFobLocationData(resultFobLocation.data);
     setPonBoxLocationData(resultPonBoxLocation.data);
     setDividerData(resultDivider.data);
     setktvAmplifierData(resultktvAmplifier.data);
   

    const uniqueData = resultLineOptic.data.listLineOpticCoordinate.filter(
      (item, index, self) => index === self.findIndex(t => t.id === item.id)
    );

    const territoryByHighwayLineId = generateTerritoryByHighwayLineId(resultLineOptic.data.listLineOpticCoordinate);

    // Добавление territory к uniqueData
    const updatedUniqueData = uniqueData.map((item) => {
      const territory = territoryByHighwayLineId[item.highwayLineId] || []; 
      return { ...item, territory }; 
    });

    const processedData = processLineOpticData(resultLineOptic.data.listLineOpticCoordinate); 
    setGroupedCoordinatesWithColorTypeAndWidth(processedData);
    setDescriptionOptic(updatedUniqueData);
    setProblemCableData(resultLineOptic.data.problemLines);

  } catch (error) {
    // console.error("Error fetching data:", error);
  } finally {
   // setLoadingCunton(false);
  }
};

//OLD отображение территории из фильтра (Округ / Регион / Ветка)  второй метод для перерисовки во внесении DrawerCanton
// export const GetCantonFilterRefresh = async ( selectedRegoin, selectedArea, selectedCanton,
//             setSwitchesData, setWellData, setPillarData, setCouplingLocationData, setFobLocationData,
//             setGroupedCoordinatesWithColorTypeAndWidth, setLoadingCunton, setPosition,setStatusModalTerritory,setDescriptionOptic, setPonBoxLocationData, setHousesData) => {  

//       setSwitchesData([]);
//       setHousesData([]);
//       setWellData([]);
//       setPillarData([]);
//       setCouplingLocationData([]);
//       setFobLocationData([]);
//       setGroupedCoordinatesWithColorTypeAndWidth([]);
//       setLoadingCunton(true);
      
//       try {
       
//         if (selectedCanton === "null") {
//          // console.error("Выберите округ!");
//           return;
//         }
//         const token = localStorage.getItem('token');

//         let apiUrlEquipment = `${GET_EQUIPMENT_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         //let apiUrlHouses = `${GET_HOUSES_POLIGON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         const resultEquipment = await axios.get(apiUrlEquipment, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });   
//         const { latitude, longitude } = resultEquipment.data[0];
//        // setPosition([latitude, longitude]);  
//         setSwitchesData(resultEquipment.data);
//         setStatusModalTerritory('canton');


//         // const resultHouses = await axios.get(apiUrlHouses, {
//         //   headers:{
//         //     'Authorization': `Bearer ${token}` 
//         //   }
//         // }); 
//         // setHousesData(resultHouses.data);  
        
//         let apiUrlWell = `${GET_WELL_CANTON_API_URL}?radius=${radiusWell}&centerLat=${latitude}&centerLon=${longitude}`;
      
//         let apiUrlPillar = `${GET_PILLAR_CANTON_API_URL}?radius=${radiusPillar}&centerLat=${latitude}&centerLon=${longitude}`;

//         let apiUrlCouplingLocation = `${GET_COUPLING_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         let apiUrlFobLocation = `${GET_FOB_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         let apiUrlLineOptic = `${GET_LINE_OPTIC_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         let apiUrlPonBoxLocation = `${GET_PON_BOX_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         const resultWell = await axios.get(apiUrlWell, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setWellData(resultWell.data);

//         const resultPillar  = await axios.get(apiUrlPillar, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setPillarData(resultPillar.data);

//         const resultCouplingLocation  = await axios.get(apiUrlCouplingLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setCouplingLocationData(resultCouplingLocation.data);

//         const resultFobLocation  = await axios.get(apiUrlFobLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setFobLocationData(resultFobLocation.data);

//         const resultPonBoxLocation  = await axios.get(apiUrlPonBoxLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setPonBoxLocationData(resultPonBoxLocation.data);

//         try {
//           const resultLineOptic = await axios.get(apiUrlLineOptic, {
//             headers:{
//               'Authorization': `Bearer ${token}` 
//             }
//           });

//           const uniqueData = resultLineOptic.data.filter((item, index, self) =>
//             index === self.findIndex((t) => t.id === item.id)
//           );

//           const territoryByHighwayLineId = generateTerritoryByHighwayLineId(resultLineOptic.data);
        
//           // Добавляем territory к uniqueData
//            const updatedUniqueData = uniqueData.map((item) => {
//              const territory = territoryByHighwayLineId[item.highwayLineId] || []; 
//              return { ...item, territory }; 
//            });

//           const processedData = processLineOpticData(resultLineOptic.data); 
//           setGroupedCoordinatesWithColorTypeAndWidth(processedData);
//           //setDescriptionOptic(uniqueData);
//           setDescriptionOptic(updatedUniqueData);

          
//         } catch (error) {
//           //console.error("Error fetching LineOptic data:", error);
//         }
//       } catch (error) {
//        // console.error("Error fetching data:", error);
//       } finally {
//         setLoadingCunton(false);
//       }
//     }

// NEW отображение территории из фильтра (Город / Страна) REFRESH
export const GetHighwayFilterRefresh = async (setSwitchesData, setWellData, setPillarData, setCouplingLocationData, setFobLocationData, setGroupedCoordinatesWithColorTypeAndWidth, 
  setLoadingSummit, selectedCity, setPosition, setStatusModalTerritory, setDescriptionOptic, setProblemCableData, handleLineClearMap ) => {  
    
  setSwitchesData([]);
  setWellData([]);
  setPillarData([]);
  setCouplingLocationData([]);
  setFobLocationData([]);
  setGroupedCoordinatesWithColorTypeAndWidth([]);
  setLoadingSummit(true);
  setProblemCableData([]);

  if (selectedCity === "null") {
    // console.error("Выберите город!");
    return;
  }

  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}` };
  
  const apiUrls = {
    lineOpticHighway: `${GET_LINE_OPTIC_HIGHWAY_API_URL}?city=${selectedCity}`,
    wellHighway: `${GET_WELL_HIGHWAY_API_URL}?city=${selectedCity}`,
    pillarHighway: `${GET_PILLAR_HIGHWAY_API_URL}?city=${selectedCity}`,
    couplingHighway: `${GET_GOUPLING_HIGHWAY_API_URL}?city=${selectedCity}`,
    fobHighway: `${GET_FOB_HIGHWAY_API_URL}?city=${selectedCity}`,
    summitCoordinate: `${GET_SUMMIT_HIGHWAY_API_URL}?city=${selectedCity}`,
  };

  try {
    await handleLineClearMap();

    // Параллельное выполнение всех запросов
    const [
      resultSummitCoordinate,
      resultWellHighway,
      resultPillarHighway,
      resultCouplingHighway,
      resultFobHighway,
      resultLineOpticHighway
    ] = await Promise.all([
      axios.get(apiUrls.summitCoordinate, { headers }),
      axios.get(apiUrls.wellHighway, { headers }),
      axios.get(apiUrls.pillarHighway, { headers }),
      axios.get(apiUrls.couplingHighway, { headers }),
      axios.get(apiUrls.fobHighway, { headers }),
      axios.get(apiUrls.lineOpticHighway, { headers })
    ]);

    const { latitude, longitude } = resultSummitCoordinate.data[0];

    // Обновление состояния
    setSwitchesData(resultSummitCoordinate.data);
    setStatusModalTerritory(CONST_HIGHWAY);

    setWellData(resultWellHighway.data);
    setPillarData(resultPillarHighway.data);
    setCouplingLocationData(resultCouplingHighway.data);
    setFobLocationData(resultFobHighway.data);
    setProblemCableData(resultLineOpticHighway.data.problemLines);
       
    const uniqueData = resultLineOpticHighway.data.listLineOpticHighwayCoordinate.filter(
      (item, index, self) => index === self.findIndex(t => t.id === item.id)
    );
  
    const processedData = processLineOpticData(resultLineOpticHighway.data.listLineOpticHighwayCoordinate); 
    setGroupedCoordinatesWithColorTypeAndWidth(processedData);
    setDescriptionOptic(uniqueData);

  } catch (error) {
    // console.error("Error fetching data:", error);
  } finally {
    setLoadingSummit(false);
  }
};

// OLD отображение территории из фильтра (Город / Страна) REFRESH
// export const GetHighwayFilterRefresh = async (setSwitchesData, setWellData, setPillarData, setCouplingLocationData, 
//   setFobLocationData, setGroupedCoordinatesWithColorTypeAndWidth, setLoadingSummit, selectedCity, setPosition, setStatusModalTerritory,setDescriptionOptic) => {  

// setSwitchesData([]);
// setWellData([]);
// setPillarData([]);
// setCouplingLocationData([]);
// setFobLocationData([]);
// setGroupedCoordinatesWithColorTypeAndWidth([]);
// setLoadingSummit(true);

// try {
//   if (selectedCity === "null") {
//    // console.error("Выберите город!");
//     return;
//   }
//   const token = localStorage.getItem('token');
     
//   let apiUrlLineOpticHighway = `${GET_LINE_OPTIC_HIGHWAY_API_URL}?city=${selectedCity}`;
  
//   let apiUrlWellHighway = `${GET_WELL_HIGHWAY_API_URL}?city=${selectedCity}`;

//   let apiUrlPillarHighway = `${GET_PILLAR_HIGHWAY_API_URL}?city=${selectedCity}`;

//   let apiUrlCouplingHighway = `${GET_GOUPLING_HIGHWAY_API_URL}?city=${selectedCity}`;

//   let apiUrlFobHighway = `${GET_FOB_HIGHWAY_API_URL}?city=${selectedCity}`;

//   let apiUrlSummitCoordinate = `${GET_SUMMIT_HIGHWAY_API_URL}?city=${selectedCity}`;

//   const resultSummitCoordinate  = await axios.get(apiUrlSummitCoordinate,{
//     headers:{
//       'Authorization': `Bearer ${token}` 
//     }
//   });
//   //
//   const { latitude, longitude } = resultSummitCoordinate.data[0];
//   //setPosition([latitude, longitude]);
//   setSwitchesData(resultSummitCoordinate.data);
//   setStatusModalTerritory('highway');

//   const resultWelllHighway = await axios.get(apiUrlWellHighway, {
//     headers:{
//       'Authorization': `Bearer ${token}` 
//     }
//   });
//   setWellData(resultWelllHighway.data);

//    const resultPillarHighway = await axios.get(apiUrlPillarHighway, {
//     headers:{
//       'Authorization': `Bearer ${token}` 
//     }
//    });
//    setPillarData(resultPillarHighway.data);

//   const resultCouplingHighway = await axios.get(apiUrlCouplingHighway, {
//     headers:{
//       'Authorization': `Bearer ${token}` 
//     }
//   });
//   setCouplingLocationData(resultCouplingHighway.data);

//   const resultFobHighway = await axios.get(apiUrlFobHighway, { 
//     headers:{
//       'Authorization': `Bearer ${token}` 
//   }});
//   setFobLocationData(resultFobHighway.data);

//   try {
//     const resultLineOpticHighway = await axios.get(apiUrlLineOpticHighway, {
//       headers:{
//         'Authorization': `Bearer ${token}` 
//       }
//     });
//     const uniqueData = resultLineOpticHighway.data.filter((item, index, self) =>
//     index === self.findIndex((t) => t.id === item.id)
//   );

//   const processedData = processLineOpticData(resultLineOpticHighway.data); 
//   setGroupedCoordinatesWithColorTypeAndWidth(processedData);
//   setDescriptionOptic(uniqueData);

//   } catch (error) {
//    // console.error("Error fetching LineOptic data:", error);
//   }
// } catch (error) {
//  // console.error("Error fetching data:", error);
// } finally {
//   setLoadingSummit(false);
// }

// }


// Fob Refresh Canton
export const GetCantonFobFilterRefresh = async ( selectedRegoin, selectedArea, selectedCanton, setFobLocationData, setLoadingCunton, setFobMarkers) => {  

      setFobLocationData([]);
      setLoadingCunton(true);
      setFobMarkers([]);
      
      try {
       
        if (selectedCanton === "null") {
         // console.error("Выберите округ!");
          return;
        }
        const token = localStorage.getItem('token');

        let apiUrlFobLocation = `${GET_FOB_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

        const resultFobLocation  = await axios.get(apiUrlFobLocation, {
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        });
        setFobLocationData(resultFobLocation.data);

      } catch (error) {
      } finally {
        setLoadingCunton(false);
      }
    }

    // PassiveNode Refresh Canton
export const GetCantonPassiveNodeFilterRefresh = async ( selectedRegoin, selectedArea, selectedCanton, setPassiveNodeLocationData, setLoadingCunton, setPassiveNodeMarkers) => {  

      setPassiveNodeLocationData([]);
      setLoadingCunton(true);
      setPassiveNodeMarkers([]);
      
      try {
       
        if (selectedCanton === "null") {
         // console.error("Выберите округ!");
          return;
        }
        const token = localStorage.getItem('token');

        let apiUrlPassiveNodeLocation = `${GET_PASSIVE_NODE_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

        const resultPassiveNodeLocation  = await axios.get(apiUrlPassiveNodeLocation, {
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        });
        setPassiveNodeLocationData(resultPassiveNodeLocation.data);

      } catch (error) {
      } finally {
        setLoadingCunton(false);
      }
    }

   // Coupling Refresh Canton
export const GetCantonCouplingFilterRefresh = async ( selectedRegoin, selectedArea, selectedCanton, setCouplingLocationData, setLoadingCunton, setCouplingMarkers) => {  
    
      setCouplingLocationData([]);     
      setLoadingCunton(true);
      setCouplingMarkers([]);
      
      try {
       
        if (selectedCanton === "null") {
         // console.error("Выберите округ!");
          return;
        }

        const token = localStorage.getItem('token');

        let apiUrlCouplingLocation = `${GET_COUPLING_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

        const resultCouplingLocation  = await axios.get(apiUrlCouplingLocation, {
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        });
        setCouplingLocationData(resultCouplingLocation.data);

       
      } catch (error) {
       // console.error("Error fetching data:", error);
      } finally {
        setLoadingCunton(false);
      }
    }

    //  // Well Refresh Canton
export const GetCantonWellFilterRefresh = async ( selectedRegoin, selectedArea, selectedCanton, setWellData, setLoadingCunton, setManholeMarkers) => {  
 
      setWellData([]);
      setLoadingCunton(true);
      setManholeMarkers([]);
      
      try {
       
        if (selectedCanton === "null") {
         // console.error("Выберите округ!");
          return;
        }
        const token = localStorage.getItem('token');

        let apiUrlEquipment = `${GET_EQUIPMENT_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

        const resultEquipment = await axios.get(apiUrlEquipment, {
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        });   
        const { latitude, longitude } = resultEquipment.data[0];
        
        let apiUrlWell = `${GET_WELL_CANTON_API_URL}?radius=${radiusWell}&centerLat=${latitude}&centerLon=${longitude}`;
      
        const resultWell = await axios.get(apiUrlWell, {
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        });
       
        setWellData(resultWell.data);

      } catch (error) {
       // console.error("Error fetching data:", error);
      } finally {
        setLoadingCunton(false);
      }
    }

     //  // Well Refresh Highway
export const GetHighwayWellFilterRefresh = async ( selectedCity, setWellData, setLoadingCunton, setManholeMarkers) => {  
 
      setWellData([]);
      setLoadingCunton(true);
      setManholeMarkers([]);
      
      try {
       
        if (selectedCity === "null") {
         // console.error("Выберите округ!");
          return;
        }
        const token = localStorage.getItem('token');
        
        let apiUrlWell = `${GET_WELL_HIGHWAY_API_URL}?city=${selectedCity}`;
      
        const resultWell = await axios.get(apiUrlWell, {
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        });
       
        setWellData(resultWell.data);

      } catch (error) {
       // console.error("Error fetching data:", error);
      } finally {
        setLoadingCunton(false);
      }
    }

       // Pillar Refresh Highway
export const GetHighwayPillarFilterRefresh = async ( selectedCity, setPillarData, setLoadingSummit, setPillarMarkers) => {  

      setPillarData([]);
      setLoadingSummit(true);
      setPillarMarkers([]);
      
      try {
       
        if (selectedCity === "null") {
         // console.error("Выберите округ!");
          return;
        }
        const token = localStorage.getItem('token');
        
        let apiUrlPillar = `${GET_PILLAR_HIGHWAY_API_URL}?city=${selectedCity}`;
      
        const resultPillar = await axios.get(apiUrlPillar, {
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        });
       
        setPillarData(resultPillar.data);

      } catch (error) {
       // console.error("Error fetching data:", error);
      } finally {
        setLoadingSummit(false);
      }
    }

      // Coupling Refresh Highway
export const GetHighwayCouplingFilterRefresh = async ( selectedCity, setCouplingLocationData, setLoadingSummit, setCouplingMarkers) => {  

      setCouplingLocationData([]);
      setLoadingSummit(true);
      setCouplingMarkers([]);
      
      try {
       
        if (selectedCity === "null") {
         // console.error("Выберите округ!");
          return;
        }
        const token = localStorage.getItem('token');
        
        let apiUrlCoupling = `${GET_GOUPLING_HIGHWAY_API_URL}?city=${selectedCity}`;
      
        const resultCoupling = await axios.get(apiUrlCoupling, {
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        });
       
        setCouplingLocationData(resultCoupling.data);

      } catch (error) {
       // console.error("Error fetching data:", error);
      } finally {
        setLoadingSummit(false);
      }
    }

    // Fob Refresh Highway
export const GetHighwayFobFilterRefresh = async ( selectedCity, setFobLocationData, setLoadingSummit, setFobMarkers) => {  

      setFobLocationData([]);
      setLoadingSummit(true);
      setFobMarkers([]);
      
      try {
       
        if (selectedCity === "null") {
         // console.error("Выберите округ!");
          return;
        }
        const token = localStorage.getItem('token');
        
        let apiUrlFob = `${GET_FOB_HIGHWAY_API_URL}?city=${selectedCity}`;
      
        const resultFob = await axios.get(apiUrlFob, {
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        });
       
        setFobLocationData(resultFob.data);

      } catch (error) {
       // console.error("Error fetching data:", error);
      } finally {
        setLoadingSummit(false);
      }
    }


  // Pillar Refresh Canton
export const GetCantonPillarFilterRefresh = async ( selectedRegoin, selectedArea, selectedCanton, setPillarData, setLoadingCunton, setPillarMarkers) => {  
   
      setPillarData([]);
      setLoadingCunton(true);
      setPillarMarkers([]);
      
      try {
       
        if (selectedCanton === "null") {
         // console.error("Выберите округ!");
          return;
        }
        const token = localStorage.getItem('token');

        let apiUrlEquipment = `${GET_EQUIPMENT_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

        const resultEquipment = await axios.get(apiUrlEquipment, {
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        });   
        const { latitude, longitude } = resultEquipment.data[0];
 
        let apiUrlPillar = `${GET_PILLAR_CANTON_API_URL}?radius=${radiusPillar}&centerLat=${latitude}&centerLon=${longitude}`;
     
        const resultPillar  = await axios.get(apiUrlPillar, {
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        });
        setPillarData(resultPillar.data);

      } catch (error) {
      } finally {
        setLoadingCunton(false);
      }
    }

  // PonBox Refresh Canton
export const GetCantonPonBoxFilterRefresh = async ( selectedRegoin, selectedArea, selectedCanton, setLoadingCunton, setPonBoxLocationData, setPonBoxMarkers) => {  

      setPonBoxLocationData([]);
      setLoadingCunton(true);
      setPonBoxMarkers([]);
      
      try {
       
        if (selectedCanton === "null") {
         // console.error("Выберите округ!");
          return;
        }
        const token = localStorage.getItem('token');

        let apiUrlPonBoxLocation = `${GET_PON_BOX_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

        const resultPonBoxLocation  = await axios.get(apiUrlPonBoxLocation, {
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        });
        setPonBoxLocationData(resultPonBoxLocation.data);
      
      } catch (error) {
      } finally {
        setLoadingCunton(false);
      }
    }

   // Cable Refresh Canton
export const GetCantonCableFilterRefresh = async ( selectedRegoin, selectedArea, selectedCanton, setGroupedCoordinatesWithColorTypeAndWidth, setLoadingCunton, setDescriptionOptic,
   setLinePoints, setCoordinatesCableLine, handleLineClearMap, setPolylinePoints, setLineEditing, setPolyline, setProblemCableData
) => {  

      // setGroupedCoordinatesWithColorTypeAndWidth([]);
      // setDescriptionOptic({});
      setLoadingCunton(true);
      // setLinePoints([]);
      // setCoordinatesCableLine([]);
      // setPolylinePoints([]);
      // setLineEditing([]);
      // setPolyline(null);
     
      
      try {
       
        if (selectedCanton === "null") {
         // console.error("Выберите округ!");
          return;
        }
        const token = localStorage.getItem('token');

        let apiUrlLineOptic = `${GET_LINE_OPTIC_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

        await handleLineClearMap();

        try {
          const resultLineOptic = await axios.get(apiUrlLineOptic, {
            headers:{
              'Authorization': `Bearer ${token}` 
            }
          });

          setProblemCableData(resultLineOptic.data.problemLines);

          const uniqueData = resultLineOptic.data.listLineOpticCoordinate.filter(
            (item, index, self) => index === self.findIndex(t => t.id === item.id)
          );

        

          const territoryByHighwayLineId = generateTerritoryByHighwayLineId(resultLineOptic.data.listLineOpticCoordinate);
        
          // Добавляем territory к uniqueData
           const updatedUniqueData = uniqueData.map((item) => {
             const territory = territoryByHighwayLineId[item.highwayLineId] || []; 
             return { ...item, territory }; 
           });
           

           const processedData = processLineOpticData(resultLineOptic.data.listLineOpticCoordinate); 
           // Устанавливаем новые данные в состояние
          setGroupedCoordinatesWithColorTypeAndWidth(processedData);
          setDescriptionOptic(updatedUniqueData);
    
   

   
        } catch (error) {
        }
      } catch (error) {
      } finally {
        setLoadingCunton(false);
      }
    }

    //перересовываем один кабель
export const GetCableByIdFilterRefresh = async ( highwayLineId, setGroupedCoordinatesWithColorTypeAndWidth, setDescriptionOptic,
   groupedCoordinatesWithColorTypeAndWidth, handleLineByIdClearMap ) => {

  try {
    const token = localStorage.getItem('token');
    const apiUrl = `${GET_LINE_OPTIC_BY_ID_CANTON_API_URL}?highwayLineId=${highwayLineId}`;

    const resultLineOptic = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    

    const processedData = processLineOpticData(resultLineOptic.data.listLineOpticCoordinate); 

    const result2 = Object.fromEntries(
      Object.entries(groupedCoordinatesWithColorTypeAndWidth)
            .filter(([key]) => key !== String(highwayLineId))
    );

     const uniqueData = resultLineOptic.data.listLineOpticCoordinate.filter(
            (item, index, self) => index === self.findIndex(t => t.id === item.id)
          );

      // Добавление территорий
    const territoryByHighwayLineId = generateTerritoryByHighwayLineId(resultLineOptic.data.listLineOpticCoordinate);
    const updatedUniqueData = uniqueData.map(item => ({
      ...item,
      territory: territoryByHighwayLineId[item.highwayLineId] || []
    }));
           
    setGroupedCoordinatesWithColorTypeAndWidth({});
    await handleLineByIdClearMap();

      setTimeout(() => {
      setGroupedCoordinatesWithColorTypeAndWidth({
        ...result2,
        ...processedData
      });

    setDescriptionOptic(prev =>
      [...prev.filter(item => item.highwayLineId !== highwayLineId), ...updatedUniqueData]
    );

    }, 100);

  } catch (error) {
    console.error('Ошибка при получении данных кабеля:', error);
  }
};


